import React, { useContext } from 'react'
import Context from '../context/Context'
import HtmlStringElement from './HtmlStringElement'

const Advertisement = () => {
  const context = useContext(Context)

  return (
    <div>
      {(context.customElementContent.CENTER_IMAGE !== '' || context.customElementContent.ADVERTISING_HEADING !== '' || context.customElementContent.ADVERTISING_CONTENT !== '') &&
      <div>
        {context.customElementContent.CENTER_IMAGE !== '' &&
        <div className="row mt-5">
          <HtmlStringElement classes={'text-center'} html={context.customElementContent.CENTER_IMAGE} />
        </div>
        }
        {(context.customElementContent.ADVERTISING_HEADING !== '' || context.customElementContent.ADVERTISING_CONTENT !== '') &&
          <div className="row mt-5">
            <div className="col-10 offset-1 col-sm-8 offset-sm-2 text-left">
              {(context.customElementContent.ADVERTISING_HEADING !== '') && <HtmlStringElement elementType={'h2'} html={context.customElementContent.ADVERTISING_HEADING} />}
              {context.customElementContent.ADVERTISING_CONTENT !== '' && <HtmlStringElement elementType={'p'} classes={'paragraph-regular-18'} html={context.customElementContent.ADVERTISING_CONTENT} />}
            </div>
          </div>
        }
      </div>
      }
    </div>
  )
}

export default Advertisement
